// CANONICAL COPY (GH #7115). src/constants/obligations/obl-risk-treatment.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-risk-treatment',
  title: 'Review risk treatment plans',
  description:
    'Review all risk treatment plans. Verify that approved resolutions are being implemented and residual risks are acceptable.',
  category: 'risk',
  scfIds: ['SCF-RSK-001'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [{ type: 'risks-approved', description: 'Risks have approved resolutions' }],
  domainActions: [{ type: 'deep-link', target: 'risks', label: 'Review Risk Register' }],
};
